import { z } from "zod";

export const onboardingStepsSchema = z.object({
  importTeam: z.boolean(),
  giveKudos: z.boolean(),
  dailyCheckIn: z.boolean(),
});

export const onboardingStatusSchema = z.object({
  applicable: z.boolean(),
  steps: onboardingStepsSchema,
  complete: z.boolean(),
});

export type OnboardingStatus = z.infer<typeof onboardingStatusSchema>;
